import React from 'react';
import ReactDOM from 'react-dom/client'
import './scss/index.css'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
// npm i serve -D
// npx serve -s build
export default function App() {
  const onClick2AnyBtn =async()=>{
    try{
      const { data: res } = await axios.get(`${APIURL}/test`)
      console.log(res)
    }catch(err){
      console.log(err)
    }
  }
  // const onClick2APIRawDataUpdate =async()=>{
  //   try {
  //     const { data: res } = await axios.post(`${APIURL}/api3/pg/nasdaqstocksall`,{data:'its a test'})
  //     console.log(res)
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }
  // const onClick2APIStockValues =async()=>{
    // try {
    //   const { data: res } = await axios.post(`${APIURL}/api3/pg/nasdaqstocks`,{data:'its a test'})
    //   const APIdata = res.data
    //   for (const x of Object.keys(APIdata)) { 
    //     const stockData=APIdata[x]
    //       function findItem1(x1){
    //         var m = (new Date()).setMonth((new Date()).getMonth() - x1)
    //         const a2 = stockData.find((x2) => new Date(x2.Date).toString().slice(4,15)=== new Date(m).toString().slice(4,15))
    //         for (var x3 = 1; a2 === undefined; x3++) {
    //         m = (new Date(m)).setDate((new Date()).getDate() - x3)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(m).toString().slice(4,15))     
    //         if(a2 !== undefined){
    //             return a2  
    //         }
    //         }
    //         return a2
    //       }
    //       function findItem2(x1){
    //         var m = (new Date()).setMonth((new Date()).getMonth() - x1)
    //         m = (new Date(m)).setDate((new Date()).getDate() - 15)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(m).toString().slice(4,15))
    //         for (var x2 = 15; a2 === undefined; x2++) {
    //         var m = (new Date()).setMonth((new Date()).getMonth() - x1)
    //         m = (new Date(m)).setDate((new Date()).getDate() - x2)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(m).toString().slice(4,15))     
    //         if(a2 !== undefined){
    //             return a2  
    //         }
    //         }
    //         return a2
    //       }
    //       function findItem3(x1){
    //         var x3 = (new Date()).setFullYear((new Date()).getFullYear() - x1)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(x3).toString().slice(4,15))
    //         for (var x2 = 1; a2 === undefined; x2++) {
    //         x3 = (new Date(x3)).setDate((new Date()).getDate() - x2)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(x3).toString().slice(4,15))     
    //         if(a2 !== undefined){
    //             return a2  
    //         }
    //         }
    //         return a2
    //       }
    //       function findItem4(x1){
    //         var m = (new Date()).setFullYear((new Date()).getFullYear() - x1)
    //         m = (new Date(m)).setMonth((new Date()).getMonth() - 6)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(m).toString().slice(4,15))
    //         for (var x2 = 1; a2 === undefined; x2++) {
    //         m = (new Date(m)).setDate((new Date()).getDate() - x2)
    //         const a2 = stockData.find((x) => new Date(x.Date).toString().slice(4,15)=== new Date(m).toString().slice(4,15))     
    //         if(a2 !== undefined){
    //             return a2  
    //         }
    //         }
    //         return a2
    //       }
    //       const today = new Date(Date.now()).toString().slice(4,15)
    //       const y6 = findItem3(6) //1
    //       const y5 = findItem3(5) //2
    //       const y4 = findItem3(4) //3
    //       const y3 = findItem3(3) //4
    //       const y2_5 = findItem4(2) //5
    //       const y2 = findItem3(2) //6
    //       const y1_5 = findItem4(1) //7
    //       const y1 = findItem3(1) //8
    //       const m10 = findItem1(10) //9
    //       const m8 = findItem1(8) //10
    //       const m6 = findItem1(6) //11
    //       const m5 = findItem1(5) //12
    //       const m4 = findItem1(4)  //13
    //       const m3 = findItem1(3)  //14
    //       const m2_5 = findItem2(2) //15
    //       const m2 = findItem1(2) //16
    //       const m1_5 = findItem2(1) //17
    //       const m1 = findItem1(1) //18
    //       const m0_5 = findItem2(0) //19
    //       const m0 = findItem1(0) //20
    //       var Items20 = [y6, y5, y4, y3, y2_5, y2, y1_5, y1, m10, m8, m6, m5, m4, m3, m2_5, m2, m1_5, m1, m0_5, m0]
    //       function trimItem(x1){
    //         //2 display year only one time
    //         const step1 = x1.map(x => {
    //           let y = {}
    //           y.date = x.Date
    //           y.name = new Date(x.Date).toISOString().substring(0, 10)
    //           y.value = (Math.round((x.Close) * 100).toFixed(2) / 100)
    //           return y 
    //         }).sort((a, b) => a.date - b.date)
    //         const step2 = [...new Map(x1.reverse().map(x => [new Date(x.Date).getYear(), x])).values()].map(x => {
    //         const y = {}
    //         y.date = x.Date
    //         y.name = new Date(x.Date).toISOString().substring(0, 10)
    //         y.value = (Math.round((x.Close) * 100).toFixed(2) / 100)
    //         return y
    //         })
    //        //3 combine together
    //       const step3 = step1.concat(step2)
    //       step3.sort((a, b) => a.date - b.date) 
    //       //4 emit duplicated item
    //       const step4 = [...new Map(step3.map(x => [x.date, x])).values()].map(x => {
    //           const y = {}
    //           y.date = x.Date
    //           y.name = x.name
    //           y.value = x.value
    //           return y
    //         })
    //         return step4
    //       }
    //       var updatedStockData = trimItem(Items20)
    //       console.log(x,' :',updatedStockData)
    //       //axios.post(`${APIURL}/api/pg/nasdaqstockvalues`, {apistockname: stockSymbol, stocks: stockData})
    //      // setStockUpdateRequired(false)

    //   // }
    //   //const stocks = ['AAPL','AMZN','GOOGL','META','MSFT','NVDA','TSLA']
    //   // for (const x of stocks) { 
    //   //   const stockData=APIdata[x]
    //   //   console.log(x,stockData)
    //   }
    // } catch (err) {
    //   console.log(err)
    // }
  // }
  return (
    <>
    <button onClick={()=>onClick2AnyBtn()}>test!</button><br/>
    {/* <button onClick={()=>onClick2APIRawDataUpdate()}>api update</button><br/>
    <button onClick={()=>onClick2APIStockValues()}>get structured</button> */}
    <br/></>
  )
}
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

